import Vue from 'vue';
import ToastV2 from '@/components/copyright/basics/toastV2/index.vue'
let $vm

const plugin = {
  install (vue, pluginOptions = {}) {
    const TsaToastV2 = vue.extend(ToastV2)
    if (!$vm) {
      $vm = new TsaToastV2({
        el: document.createElement('div')
      })
      document.body.appendChild($vm.$el)
    }

    const toast = {
      show (options = {}) {
        $vm.message = options.message
        $vm.duration = options.duration || 3000
        $vm.style = options.style
        $vm.show = true
        $vm.type = options.type || 'info' // success, warning, error, info
        if (options.onAction) {
            $vm.action = options.onAction
            $vm.actionShow = true
        } else {
           $vm.actionShow = false
        }
        setTimeout(() => {
          $vm.show = false
        }, $vm.duration)
      },
      hide () {
        $vm.show = false
      }
    }
    if (!vue.prototype.$TsaToastV2) {
      vue.prototype.$TsaToastV2 = toast
    }
  }
}
export default plugin